module.exports = __webpack_public_path__ + "img/1.259362f1.png";